var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "px-4 title primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Scenarios')))]), _vm._l(_vm.scenarios, function (scenario) {
    return [_c('Scenario', {
      attrs: {
        "id": scenario.m_AdvID
      }
    })];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }